import React from 'react';
import { Tooltip } from 'antd';

const NetworkFormatter = ({ row, title }) => {
  if (!row?.network) {
    return null;
  }

  const networkKey = row.network.toLowerCase();
  const displayKey = networkKey === 'facebook' ? 'meta' : networkKey;
  const displayTitle = title || displayKey.charAt(0).toUpperCase() + displayKey.slice(1);

  return (
    <Tooltip
      placement='top'
      title={displayTitle}
      destroyTooltipOnHide={true}
      mouseEnterDelay={0.1}
      className='cursor-pointer'
    >
      <span className='flex items-center justify-center'>
        <img src={`/icons/networks/${displayKey}.svg`} alt={displayKey} className='w-4 h-4' />
      </span>
    </Tooltip>
  );
};

export default NetworkFormatter;
